export default {"src":"/_next/static/media/play.89ce06fd.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};